<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
      <v-col cols="4" sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <!-- <app-modal-import-task
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="$emit('reloadTasks')"
              :filter="filter"
            >
              <template v-slot:title> Importação de Tarefas </template>
            </app-modal-import-task> -->
            <app-modal-insert-task
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              :solutionId="solutionsIds"
              @onSave="$emit('reload')"
            >
              <template v-slot:title>
                Cadastrar {{ isAT ? "Atividade" : "Tarefa" }}
              </template>
            </app-modal-insert-task>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="tasks"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.descricao="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ diminuirValue(item.descricao) }}</span
                >
              </template>
              <div style="max-width: 500px">{{ item.descricao }}</div>
            </v-tooltip>
          </template>
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col>
                <app-modal-insert-task
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @onSave="$emit('reload')"
                >
                  <template v-slot:title>
                    Edição de {{ isAT ? "Atividade" : "Tarefa" }}
                  </template>
                </app-modal-insert-task>
              </v-col>

              <v-col>
                <app-modal-delete-task
                  :payload="item"
                  @onDelete="$emit('reload')"
                >
                  <template v-slot:title>
                    Deletar {{ isAT ? "Atividade" : "Tarefa" }}
                  </template>
                </app-modal-delete-task>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertTask from "./ModalInsert";
import AppModalDeleteTask from "./ModalDelete";
import AppModalImportTask from "@/modules/task/components/city/ModalImport";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppTaskList",
  components: {
    AppModalInsertTask,
    AppModalDeleteTask,
    AppModalImportTask,
  },
  props: {
    filter: { type: Object, required: true },
    tasks: { type: Array, required: true },
    solutionId: "",
  },
  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  data() {
    return {
      headers: [],
      solutionsIds: null,
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Tarefas",
          disabled: true,
          href: "termo-referencia",
        },
      ],
    };
  },
  watch: {
    solutionId(item) {
      this.solutionsIds = item;
    },
  },
  methods: {
    diminuirValue(item) {
      if (item && item.length > 20) {
        return item.substring(0, 20) + "...";
      }

      return item;
    },
  },
  mounted() {
    this.headers = [
      {
        text: "#",
        value: "tarefaId",
        sortable: false,
        width: "5%",
      },
      {
        text: "Solução",
        value: "solucao.nome",
        width: "30%",
      },
      {
        text: this.isAT || this.isGov ? "Atividade" : "Tarefa",
        align: "left",
        value: "nome",
        width: "30%",
      },
      {
        text: "Descrição",
        value: "descricao",
        width: "20%",
      },

      {
        text: "Ações",
        value: "acoes",
        sortable: false,
        width: "15%",
      },
    ];

    if (this.isAT || this.isGov) {
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Atividades",
          disabled: true,
          href: "termo-referencia",
        },
      ];
      this.headers = [
        {
          text: "#",
          value: "eixoId",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Atividade",
          value: "solucao.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ];
    }
    this.solutionsIds = this.filter.solucaoId;
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
